import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import ContentBlock from '../../internal/components/ContentBlock/ContentBlock';
import ContentGroup from '../../internal/components/ContentGroup/ContentGroup';
import ContentItem from '../../internal/components/ContentItem/ContentItem';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import { ImageWithCaption } from '../ImageWithCaption';
import React from 'react';
import settings from 'carbon-components/es/globals/js/settings';
import { VideoPlayer } from '../VideoPlayer';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Content Block - Segmented pattern.
 */

var ContentBlockSegmented = function ContentBlockSegmented(_ref) {
  var copy = _ref.copy,
      cta = _ref.cta,
      heading = _ref.heading,
      mediaType = _ref.mediaType,
      mediaData = _ref.mediaData,
      items = _ref.items,
      aside = _ref.aside;
  return React.createElement("div", {
    "data-autoid": "".concat(stablePrefix, "--content-block-segmented"),
    className: "".concat(prefix, "--content-block-segmented")
  }, React.createElement(ContentBlock, {
    heading: heading,
    copy: copy,
    cta: cta,
    aside: aside
  }, _renderMedia(mediaType, mediaData), _renderGroup(items)));
};
/**
 * renders either video or image content
 *
 * @param {string} type cta type ( external | jump | local)
 * @param {object} data cta type ( external | jump | local)
 * @private
 * @returns {*} media component
 */


var _renderMedia = function _renderMedia(type, data) {
  if (data) {
    return React.createElement("div", {
      "data-autoid": "".concat(stablePrefix, "--content-block-segmented__media")
    }, type === 'image' && React.createElement(ImageWithCaption, data), type === 'video' && React.createElement(VideoPlayer, data));
  }
};
/**
 *
 * @param {object} items content item data
 * @returns {*} JSX Component with the media
 */


var _renderGroup = function _renderGroup(items) {
  return items.map(function (item, index) {
    return React.createElement(ContentGroup, {
      heading: item.heading,
      key: index,
      cta: item.cta && (item.cta.type === 'jump' || item.cta.type === 'local') ? _objectSpread({
        style: 'text'
      }, item.cta) : undefined
    }, React.createElement("div", {
      "data-autoid": "".concat(stablePrefix, "--content-block-segmented__content-group")
    }, React.createElement(ContentItem, {
      copy: item.copy,
      key: index
    }), item.image && React.createElement("div", {
      "data-autoid": "".concat(stablePrefix, "--content-block-segmented__media")
    }, React.createElement(ImageWithCaption, item.image))));
  });
};

export default ContentBlockSegmented;